import '@chillibean/component-library/index.css';

import { ToastNotifications } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useRef, useEffect, useMemo } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import AppContext from '../../context/AppContext';
import { Account, User } from './models';
import { ActivitiesPage } from './pages';
import { setInternalSettings } from './redux/actions';
import store from './redux/store';

function ActivitiesEntryPoint(props) {
  const { account, accountTimezone, authenticityToken, user } = props;

  const notificationDomRef = useRef(null);

  useEffect(() => {
    const internalValues = {
      account: new Account(account),
      accountTimezone: accountTimezone,
      authenticityToken: authenticityToken,
      user: new User(user),
    };

    store.dispatch(setInternalSettings(internalValues));
  }, []);

  const appContextProviderValue = useMemo(() => ({ notificationDomRef }), [notificationDomRef]);

  return (
    <Provider store={store}>
      <Router basename="activities">
        <ToastNotifications />
        <AppContext.Provider value={appContextProviderValue}>
          {/* <ErrorBoundary> */}
          <ActivitiesPage />
          {/* </ErrorBoundary> */}
        </AppContext.Provider>
      </Router>
    </Provider>
  );
}

ActivitiesEntryPoint.propTypes = {
  account: PropTypes.shape().isRequired,
  accountTimezone: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  user: PropTypes.shape().isRequired,
};

export default ActivitiesEntryPoint;
